import React, { useMemo } from 'react'

import { useModifierContext } from 'public/components/online_ordering/ModifierContext'
import { ModifierGroup } from 'public/components/online_ordering/types'

import SelectionList from 'public/components/default_template/online_ordering/item_modal/SelectionList'
import { t } from 'src/translations'

type ModifiersListProps = {
  groups: ModifierGroup[]
  modifiersInvalid?: boolean
}

export const ModifiersList = ({
  groups,
  modifiersInvalid = false
}: ModifiersListProps) => {
  const { invalidRequiredGroups } = useModifierContext()

  const hasInvalidModifiers = useMemo(
    () => modifiersInvalid && invalidRequiredGroups?.length > 0,
    [modifiersInvalid, invalidRequiredGroups]
  )

  return (
    <div data-testid='modifierGroups'>
      {groups?.map((group: ModifierGroup, index) => (
        <SelectionList
          key={group.guid}
          group={group}
          firstModifierGroup={index === 0}
        />
      ))}

      {hasInvalidModifiers && (
        <div role='alert' className='modifiersErrorAlert'>
          <div className='errorMessage'>
            {t('modifiers-section.required-modifiers-error')}
          </div>
          <ul className='errorList'>
            {invalidRequiredGroups.map((group) => (
              <li key={group.guid}>{group.name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
